import { Value, ParsedMetric } from "./metrics.types";

function parseExpression(expr: any): {
    formula: string;
    values: Value[];
} {
    const values: Value[] = [];

    function traverse(node: any): string {
        if (node.value) {
            const val = node.value;
            const index = values.length;
            if (val.meta) {
                values.push({
                    value: val.value.number,
                    ref: `$${index}`,
                    meta: {
                        period: val.meta.origPeriod,
                        accountId: val.meta.accountId,
                        dataAssetId: val.meta.dataAssetId,
                        location: val.meta.loc,
                    },
                });
            } else {
                values.push({
                    value: val.value.number,
                    ref: `$${index}`,
                });
            }
            return `$${index}`;
        }

        if (node.add) {
            const parts = node.add.map((n: any) => {
                const result = traverse(n);
                const needsParens = n.sub;
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" + ");
        }

        if (node.sub) {
            const parts = node.sub.map((n: any, idx: number) => {
                const result = traverse(n);
                const needsParens = idx > 0 && (n.add || n.sub);
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" - ");
        }

        if (node.mul) {
            const parts = node.mul.map((n: any) => {
                const result = traverse(n);
                const needsParens = n.add || n.sub;
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" * ");
        }

        if (node.div) {
            const parts = node.div.map((n: any, idx: number) => {
                const result = traverse(n);
                const needsParens =
                    n.add || n.sub || (idx > 0 && (n.mul || n.div));
                return needsParens ? `(${result})` : result;
            });
            return parts.join(" / ");
        }

        return "";
    }

    const formula = traverse(expr);
    return { formula, values };
}

export function parseMetricLineage(data: any): ParsedMetric[] {
    const results: ParsedMetric[] = [];

    if (!data.metrics) return results;

    for (const metricKey of Object.keys(data.metrics)) {
        const metricArray = data.metrics[metricKey];

        for (const metric of metricArray) {
            if (!metric.lineagedValues) continue;

            for (const lineagedValue of metric.lineagedValues) {
                if (lineagedValue.expr) {
                    const { formula, values } = parseExpression(
                        lineagedValue.expr,
                    );

                    results.push({
                        period: lineagedValue.period,
                        result: lineagedValue.value,
                        formula,
                        values,
                    });
                } else if (lineagedValue.lineage) {
                    results.push({
                        period: lineagedValue.period,
                        result: lineagedValue.value,
                        formula: "$0",
                        values: [
                            {
                                value: lineagedValue.value,
                                ref: "$0",
                                meta: {
                                    period: lineagedValue.lineage.origPeriod,
                                    accountId: lineagedValue.lineage.accountId,
                                    dataAssetId:
                                        lineagedValue.lineage.dataAssetId,
                                    location: lineagedValue.lineage.loc,
                                },
                            },
                        ],
                    });
                }
            }
        }
    }

    return results;
}
